import React from "react";

function Icon({ className = null, seasonColor, id = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="280"
      viewBox="0 0 200 280"
      preserveAspectRatio="none"
      className={className}
    >
      <defs>
        <clipPath id={`${id}-clip-path-2`}>
          <path
            fill="#fff"
            d="M0 0H200V280H0z"
            data-name="Rectangle 1794"
            transform="translate(-8646 -11193)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(#${id}-clip-path-2)`}
        data-name="Groupe de masques 60"
        transform="translate(8646 11193)"
      >
        <g data-name="Groupe 11589" transform="translate(-8895.098 -11329.383)">
          <path
            fill="#afc620"
            d="M347.408 321.732S401.031 90.311 24.264 0c0 0-27.281 47.977-23.988 132.642 0 0 251.175 45.156 347.132 189.09"
            data-name="Tracé 2657"
            transform="rotate(-36 637.432 207.057)"
          ></path>
          <path
            fill="#e0c6a2"
            d="M42.767 104.406l83.891-134.253a306.342 306.342 0 00-152.411-46.56L-31.3 82.408a148.851 148.851 0 0174.065 22"
            data-name="Tracé 2658"
            transform="translate(424.618 81.59)"
          ></path>
          <path
            fill={seasonColor}
            d="M74.065 180.813L157.956 46.56A306.342 306.342 0 005.545 0L0 158.815a148.851 148.851 0 0174.065 22"
            data-name="Tracé 2659"
            transform="rotate(-59 188.589 -54.145)"
          ></path>
          <path
            fill="#165227"
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2660"
            transform="translate(382.628 285.341)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
